import { render, staticRenderFns } from "./AddIcon.vue?vue&type=template&id=c50406b6&"
import script from "./AddIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AddIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports